import { SortedLeagues } from '@/hooks/use-fantasy-league-configs';

export const toLeagueNavigatorItem = ({ league, eventsCount }: SortedLeagues) => ({
    id: league.league,
    label: league.label,
    image: { uri: league.icon ?? '' },
    disabled: eventsCount === 0,
});
